export default {
      id: "icon-double-chevron-left-usage",
      viewBox: "0 0 13 14",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-double-chevron-left",
      toString: function () {
        return this.url;
      }
    }